import { render, staticRenderFns } from "./ConversationView.vue?vue&type=template&id=40f5ab50"
import script from "./ConversationView.vue?vue&type=script&lang=js"
export * from "./ConversationView.vue?vue&type=script&lang=js"
import style0 from "./ConversationView.vue?vue&type=style&index=0&id=40f5ab50&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports